import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {ImageWithBoundingBoxComponent} from './image-with-bounding-box.component';
import {InputMaskModule} from '@ngneat/input-mask';
import {CurrencySelectionModule} from '../currency-selection-component/currency-selection.module';
import {AngularMaterialLibraryModule} from '../../angular-material/angular-material-library.module';
import {DirectiveLibraryModule} from '../../directives/directive-library.module';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        InputMaskModule,
        CurrencySelectionModule,
        AngularMaterialLibraryModule,
        DirectiveLibraryModule,
        ImageWithBoundingBoxComponent
    ],
    exports: [
        ImageWithBoundingBoxComponent,
    ]
})
export class ImageModule {

}
